import { Component, OnInit } from '@angular/core';
import { IndicationGroup } from '@app/models/indication';
import { SharedService } from '../../services/shared.service';
import { vennHealthConstants } from '../vennHealthConstants';

@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.css']
})
export class ResultsComponent implements OnInit {

  availableDataSets: Array<{ text: string; value: number }> = vennHealthConstants.nHanesYears;

  allIndications: IndicationGroup[] = [];

  showResults = false; // shows/hides the charts and grids depending on true/false
  showCharts = false;

  constructor(private readonly sharedService: SharedService) { }

  ngOnInit(): void {

    this.sharedService.allIndications.subscribe(data => {
      if (data) {
        this.allIndications = data;
      }
    });

    this.sharedService.resetQuery.subscribe(
      reset => {
        if (reset && reset === true) {
          this.showResults = false;
          // TODO blank out results subscription values
          this.resetSelections();
        }
      }
    );

    this.sharedService.runQuery.subscribe(
      run => {
        if (run && run === true) {
          this.showResults = true;
        }
      }
    );

    this.sharedService.rawResultsData.subscribe(
      data => {
        if (data !== null) {
          const rawPivotTableData = data.pivotTableData;
          const selectedIndicationsCount = rawPivotTableData && rawPivotTableData.length > 0 ? rawPivotTableData.length : 0;
            if (selectedIndicationsCount > 1 ) {
              this.showCharts = true;
            } else {
              this.showCharts = false;
            }
        }
      }
    );

  }
  
  resetSelections() {
    this.allIndications.forEach(group => {
      group.indications.forEach(i => {
        i.selected = false;
        i.selections = [];
      });
    });
    this.sharedService.setAllIndications(this.allIndications);
    this.sharedService.setSeletedDataSets(this.availableDataSets);
    this.sharedService.setActiveQueryId(0);
  }
}
 

